import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BsFillPersonFill } from 'react-icons/bs';
import { colors } from '../constants';

const AVATAR_SIZES = {
  medium: 'medium',
  large: 'large',
  big: 'big',
};

const getAvatarSize = size => {
  switch (size) {
    case AVATAR_SIZES.medium:
      return '24px';
    case AVATAR_SIZES.large:
      return '32px';
    case AVATAR_SIZES.big:
      return '64px';
    default:
      return '32px';
  }
};

const StyledAvatar = styled.img`
  width: ${props => getAvatarSize(props.size)};
  min-width: ${props => getAvatarSize(props.size)};
  height: ${props => getAvatarSize(props.size)};
  margin-right: 10px;
  border-radius: 100%;
`;

const Avatar = ({ image, size, title }) => {
  return image ? (
    <StyledAvatar title={title} size={size} src={image} />
  ) : (
    <BsFillPersonFill
      title={title}
      style={{
        minWidth: getAvatarSize(size),
        width: getAvatarSize(size),
        height: getAvatarSize(size),
        marginRight: '10px',
        borderRadius: '100%',
        outline: `${colors.white} 2px solid`,
        background: `${colors.white}`,
      }}
    />
  );
};

Avatar.propTypes = {
  image: PropTypes.node,
  size: PropTypes.oneOf(Object.values(AVATAR_SIZES)),
  title: PropTypes.string,
};

Avatar.defaultProps = {
  size: AVATAR_SIZES.large,
};

export default Avatar;
